<template>
  <img
    src="/ele-file-list/ic_file_pdf.png"
    style="width: 1em; height: 1em; object-fit: contain"
  />
</template>
